import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { PatchChangePasswordTO } from "src/app/data/schema/User/PatchChangePasswordTO";
import { ProfileService } from "../../services/profile.service";

@Component({
    selector: "app-profile-change-password",
    templateUrl: "./profile-change-password.component.html",
    styleUrls: ["./profile-change-password.component.scss"]
})
export class ProfileChangePasswordComponent implements OnInit, OnDestroy {
    public loading$: Observable<boolean>;
    public editMode: boolean;
    public formGroup: UntypedFormGroup;

    public cardData: PatchChangePasswordTO;

    _validPassword: boolean;
    _password: string;

    constructor(
        private translate: TranslateService,
        private profileService: ProfileService,
        private snackBar: SnackbarService,
        private subscriptionService: SubscriptionService
    ) {
        this.editMode = false;
        this.cardData = {
            senhaAtual: "",
            novaSenha: "",
            confirmacaoSenha: ""
        };

        this.loading$ = this.profileService.getLoadingAsync();
    }

    ngOnDestroy(): void {
        this.profileService.clear();
    }

    ngOnInit(): void {
        this.formGroup = new UntypedFormGroup({
            senhaAtual: new UntypedFormControl({ value: "", disabled: !this.editMode }, Validators.required)
        });

        this.formGroup.markAllAsTouched();
    }

    toggleEdition(): void {
        if (this.editMode) {
            if (!this.formGroup.valid) {
                this.translate.get("MESSAGES.REQUIRED").subscribe((res) => {
                    this.snackBar.showMessage(res);
                });
                return;
            }

            this.formGroup.controls["senhaAtual"].disable();
            this.save();
        } else {
            this.formGroup.controls["senhaAtual"].enable();
        }

        this.editMode = !this.editMode;
    }

    private save(): void {
        if (!this._validPassword) return;

        this.profileService.updateUserPassword(this.formGroup.value.senhaAtual, this._password);
    }

    validPassword($event: boolean): void {
        this._validPassword = $event;
    }

    password(event: string): void {
        this._password = event;
    }

    getPasswordRegex(): string {
        return this.subscriptionService.currentSubscription?.loginSettings?.defaultLoginOptions?.passwordRegex;
    }

    getPasswordCustomRules(): string {
        return this.subscriptionService.currentSubscription?.loginSettings?.defaultLoginOptions?.passwordCustomRules;
    }
}
